import {Page, PageRenderer} from '@/modules/report_server/domain/page'
import {PageGenerator} from '@/modules/report_server/domain/page_generator'
import {ContentProvider} from '@/modules/report_server/domain/content_provider'
import {nextTick} from '@/modules/report_server/infra/next_tick'
import AnexoIReportPage from './AnexoIReportPage.vue' 

export interface AnexoIData {
  grantor?: { name: string, nif: string, municipio: string, via: string, numero: string };
  entity?: { name: string, nif: string, municipio: string, via: string, numero: string, representativeName: string, representativeNif: string, representativeRole?: string, representativeMunicipio?: string, representativeVia?: string, representativeNumero?: string, address: string };
  provider: { name: string, nif: string };
  grantorSign: { place: string, day: string, month: string, year: string };
  providerSign: { place: string, day: string, month: string, year: string };
}


class OtorgamientoRep implements Page {
    id = "anexo_i_page_1"
    component: any
    visible = false
    pageNum = 1
    renderer: PageRenderer | undefined
    reportData: AnexoIData
    isPage1: boolean = false
    isPage2: boolean = false

    constructor(reportData: AnexoIData) { // recibir solo info cliente
        this.component = { ...AnexoIReportPage }
        this.reportData = reportData
    }

    async setPageNum(pageNum: number): Promise<void> {
        return new Promise((resolve) => {
            nextTick(() => {
                this.pageNum = pageNum;
                this.id = pageNum.toString();
                resolve();
            });
        });
    }

    async setVisible(visible: boolean): Promise<void> {
        return new Promise((resolve) => {
            nextTick(() => {
                this.visible = visible;
                resolve();
            });
        });
    }

    setRenderer(renderer: PageRenderer): void {
        this.renderer = renderer;
    }
}


class AnexoIPageGenerator implements PageGenerator {
    reportData: AnexoIData
    pages: OtorgamientoRep[]=[]
    private pageCreationCount: number = 0

    constructor(reportData: AnexoIData) {
        this.reportData = reportData;
    }

    async getInitialPage(): Promise<Page> {
        const page = new OtorgamientoRep(this.reportData);
        page.isPage1 = true
        this.pages.push(page)
        return page;
    }

    async getNextPage(page: Page): Promise<Page> {
        const newPage = new OtorgamientoRep(this.reportData);
        newPage.isPage2 = true
        this.pages.push(newPage)
        return newPage
    }

    async canGrow(page: Page): Promise<boolean> {
        // Permitir crecer solo una vez para generar la página 2
        // Después de eso, retornar false para evitar el ciclo infinito
        const page_pdf = page as OtorgamientoRep
        if (page_pdf.isPage1 && this.pageCreationCount === 0) {
            this.pageCreationCount++
            return true
        }
        return false
    }

    async grow(page: OtorgamientoRep): Promise<void> {
        // Cuando crece, mostrar ambas páginas (1 y 2)
        // Esto causará que se desborde y el motor creará una nueva página
        page.isPage1 = true
        page.isPage2 = true

        return new Promise((resolve) => {
            nextTick(() => {
                resolve()
            })
        })
    }


    async shrink(page: OtorgamientoRep): Promise<void> {
        // Cuando se reduce, volver a mostrar solo la página 1
        page.isPage1 = true
        page.isPage2 = false

        return new Promise((resolve) => {
            nextTick(() => {
                resolve()
            })
        })
    }
}


export class AnexoIProvider implements ContentProvider {
    reportData: AnexoIData

    constructor(reportData: AnexoIData) {
        this.reportData = reportData;
    }

    async getContent() {
        const generator = new AnexoIPageGenerator(this.reportData);
        return [generator];
    }
}